/* eslint-disable react/no-danger */

import React from 'react';
import { useSelector } from 'react-redux';

import {
	useIsBelowSmallOnly,
	useIsSmallAndAbove,
} from '../../../hooks/mediaQueries';
import { convertStringToValidHtml } from '../../../utilities/lister-utilities';
import DynamicBanner from '../DynamicBanner/DynamicBanner';
import InsecureBanner from './InsecureBanner';
import JsonBanner from './JsonBanner';

export const TopBanner = () => {
	const {
		categoryId,
		seoHtml: { MobileTop, DesktopTop } = {},
		banners: { Top } = {},
	} = useSelector((state) => state);

	const isBelowSmallOnly = useIsBelowSmallOnly();
	const isSmallAndAbove = useIsSmallAndAbove();

	const getBannerConfig = (banner) => {
		let bannerConfig;
		const convertedHtml = convertStringToValidHtml(banner);

		try {
			bannerConfig = JSON.parse(convertedHtml);
		} catch (error) {
			throw new Error('Error parsing banner config, check config is valid.');
		}

		if (!bannerConfig) {
			return null;
		}

		return bannerConfig[categoryId];
	};

	// Dynamic Banners
	if (Top?.length > 0) {
		return <DynamicBanner {...Top[0]} />;
	}

	if (!MobileTop && !DesktopTop) {
		return null;
	}

	if (isBelowSmallOnly && MobileTop?.includes('text/css')) {
		return (
			<InsecureBanner
				classes="text-center pb-4"
				testId="top-banner-small"
				banner={MobileTop}
			/>
		);
	} else if (isSmallAndAbove && DesktopTop?.includes('text/css')) {
		return (
			<InsecureBanner
				classes="text-center"
				testId="top-banner-large"
				banner={DesktopTop}
			/>
		);
	}

	let configToUse;

	if (isBelowSmallOnly && MobileTop) {
		configToUse = MobileTop;
	} else if (isSmallAndAbove && DesktopTop) {
		configToUse = DesktopTop;
	}

	const bannerConfig = getBannerConfig(configToUse);

	if (!bannerConfig) {
		return null;
	}

	return <JsonBanner {...bannerConfig} />;
};

export default TopBanner;
